import styled from 'styled-components';
import { BarGraphProps, BarProps } from './type';

export const WrapBarGraphStyle = styled.div<BarGraphProps>`
  overflow-x: scroll;
  display: grid;
  gap: 10px;
  overflow-y: visible;
  grid-template-columns: max-content 1fr;
  width: ${({ maxWidth }) => maxWidth || '100%'};
  height: ${({ maxHeight }) => `calc(${maxHeight} || '100%' + 100px)`};
`;

export const WrapLabelStyle = styled.div<BarGraphProps>`
  width: ${({ labelWidth }) => labelWidth || '50px'};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: ${({ maxHeight }) => `calc(${maxHeight})`};
  padding-bottom: 40px;
  padding-top: 60px;
`;

export const WrapBarStyle = styled.div<BarProps>`
  box-shadow: 4px 4px 14px 0px #c1d5ee inset, -4px -4px 9px 0px rgba(255, 255, 255, 0.88) inset;
  background-color: #e3edf7;
  border-radius: 10px;
  height: 100%;
  display: flex;
  align-items: flex-end;
  position: relative;
  ::before {
    content: ${({ label }) => (label ? `'${label}'` : '')};
    position: absolute;
    bottom: -20px;
    text-align: center;
    width: 100%;
    z-index: 1;
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    color: #5b5d71;
  }
  ::after {
    content: ${({ title: name }) => (name ? `'${name}'` : '')};
    position: absolute;
    bottom: -40px;
    text-align: center;
    width: 100%;
    z-index: 1;
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    color: #5b5d71;
  }

  ${({ isSelected }) =>
    isSelected &&
    `
    opacity: 0.5;
    `};
`;

export const BarStyle = styled.span<BarProps>`
  height: ${({ graphValue }) => `${graphValue < 100 ? graphValue : 100}%` || '0%'};
  max-height: ${({ graphValue }) => `calc(${graphValue < 100 ? graphValue : 100}%)` || '0%'};
  width: ${({ size }) => size || '12px'};
  border-radius: 10px;
  background: ${({ theme: { colors }, color }) =>
    color || `linear-gradient(to bottom, #50CAFF, ${colors.blue500})`};
  position: relative;
  ${({ isSelected, popUpText }) =>
    isSelected &&
    `
  ::before{
    content: '${popUpText}';
    width: max-content;
    top: -30px; 
    position: absolute;
    padding: 6px 8px;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #E3EDF7;
    border-radius: 6px;
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    color: #557FC3;
    z-index: 1;
    box-shadow: 4px 4px 20px 0px rgba(111, 140, 176, 0.41), -6px -6px 20px 0px #FFF, 2px 2px 4px 0px rgba(114, 142, 171, 0.10);
    }

    ::after{
    content: '';
    z-index: 1;
    width: 15px;
    height: 15px;
    top: -15px;
    background: #E3EDF7;
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%) rotate(45deg);
    }
    `};
`;
